import { Cancel, Edit, Save } from '@mui/icons-material';
import { Button, IconButton, Stack, Tooltip } from '@mui/material';

type EditButtonGroupProps = {
  readonly isEditMode: boolean;
  readonly setEditMode: (bool: boolean) => void;
  readonly onSave?: () => void;
  readonly onCancel?: () => void;
  readonly disabled?: boolean;
  readonly disabledTooltip?: string;
};

export const EditButtonGroup = (props: EditButtonGroupProps) => {
  const { isEditMode, setEditMode, onSave, onCancel, disabled = false, disabledTooltip } = props;

  if (!isEditMode) {
    return (
      <Stack
        direction="row"
        sx={{ width: '100%', textAlign: 'right', height: 'fit-content' }}
        spacing={1}
        justifyContent="end"
      >
        <Tooltip title={disabled ? (disabledTooltip ?? '') : ''}>
          <span>
            <IconButton size="small" onClick={() => setEditMode(true)} disabled={disabled} aria-label="Edit">
              <Edit
                data-testid="edit-button"
                sx={{
                  color: disabled ? 'text.disabled' : 'text.brand',
                  fontSize: '18px',
                }}
              />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      sx={{ width: '100%', textAlign: 'right', height: 'fit-content' }}
      spacing={1}
      justifyContent="end"
    >
      <Button
        data-testid="cancel-button"
        startIcon={<Cancel />}
        size="small"
        onClick={() => {
          setEditMode(false);
          onCancel?.();
        }}
      >
        Abbrechen
      </Button>
      <Button
        data-testid="save-button"
        variant="contained"
        startIcon={<Save />}
        size="small"
        onClick={() => {
          onSave?.();
          setEditMode(false);
        }}
      >
        Speichern
      </Button>
    </Stack>
  );
};
